export default function H2({ title, fontWeight = 'bold', theme = "title", className = "" }) {
    return (
        <h2 className={`text-xl md:text-3xl font-${fontWeight} text-${theme} ${className}`}>
            {title}
        </h2>
    );
}
